<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-公益项目">
    <div class="swipe">
      <img src="../assets/banner9.png" alt />
    </div>
    <!-- <Class :nav="nav" ></Class> -->
    <!-- <div style="width:80%;margin:0 auto;"> -->
    <!-- <AllHeader title="项目捐赠"></AllHeader> -->
    <!-- <h4 style="margin:.4rem">sdasdasdasdas</h4> -->
    <!-- </div> -->
    <div class="program">
      <div class="pHeader">
        <div
          data-wow-duration="1s"
          :data-wow-delay="index / 2 + 's'"
          class="tBox wow fadeInLeft"
          v-for="(item, index) in totalData"
          :key="index"
        >
          <div class="oneBox">
            <h3>{{ item.name }}</h3>
            <CountTo
              :usegroup="true"
              :simplify="false"
              :delay="index * 500"
              count-class="count-text"
              unit-class="unit-class"
              :end="item.total"
              :decimals="item.total - parseInt(item.total) == 0 ? 0 : 2"
            ></CountTo>
          </div>
        </div>
      </div>
      <div class="pTitle wow fadeInUp" data-wow-duration="1s">
        <h4>FUNDRAISING PROJECTS</h4>
        <h1>募捐项目</h1>
      </div>
      <div class="pNav wow fadeInUp" data-wow-duration="1s">
        <ul>
          <li
            @click="changNav(item, index)"
            :class="index == currentIndex ? 'selected' : ''"
            v-for="(item, index) in nav"
            :key="index"
          >
            {{ item.name }}
          </li>
        </ul>
        <h4 @click="Proposals">
          项目申请
          <i class="el-icon-thumb"></i>
        </h4>
      </div>
      <div class="pWrapper">
        <div
          class="oneWrapper wow fadeInUp"
          data-wow-duration="1s"
          :data-wow-delay="index / 4 + 's'"
          :style="(index + 1) % 3 == 0 ? 'margin-right:0' : ''"
          v-for="(item, index) in programData"
          :key="index"
        >
          <div class="show">
            <img class="showImg" :src="item.picture" alt />
            <img
              class="showIcon"
              :src="
                require('../assets/' +
                  (item.status == 2
                    ? 'start'
                    : item.status == 3
                    ? 'ing'
                    : item.status == 4
                    ? 'end'
                    : '') +
                  '.png')
              "
              alt
            />
          </div>
          <div class="content">
            <h2 @click="$router.push(`/programDetail/${item.id}`)">
              {{ item.name }}
            </h2>
            <p>
              已募集资金(元)：
              <CountTo
                :usegroup="true"
                :simplify="false"
                count-class="count-text"
                unit-class="unit-class"
                :end="item.raisefund"
              ></CountTo>
            </p>
            <p>
              已资助资金(元)：
              <CountTo
                :usegroup="true"
                :simplify="false"
                count-class="count-text"
                unit-class="unit-class"
                :end="item.recipients"
              ></CountTo>
            </p>
          </div>
        </div>
      </div>
      <div class="tspage" v-if="paginations.total > paginations.page_size">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="paginations.page_index"
          :page-size="paginations.page_size"
          :total="paginations.total"
          layout="prev, pager, next"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Class from "@/components/Class.vue"
import AllHeader from "@/components/AllHeader.vue"
import CountTo from "@/components/count-to"
import Bus from "@/utils/bus.js"
import { BASE_URL } from "@/utils/base.js"
import { getProgramList, getAllList } from "@/api/user.js"
import WOW from "wowjs"
export default {
  data() {
    return {
      nav: [
        { name: "全部", status: -1 },
        { name: "募集中", status: 2 },
        { name: "运营中", status: 3 },
        { name: "已结束", status: 4 },
      ],
      totalData: [
        { name: "募捐项目", total: 0 },
        { name: "募捐总额", total: 0 },
        { name: "捐赠人数", total: 0 },
        { name: "受助人数", total: 0 },
      ],
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 6, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      // nav: [
      //   { title: "合作模式", url: "hzms" },
      //   { title: "项目捐赠", url: "xmjz" }
      // ],
      currentIndex: 0,
      programData: [],
    }
  },
  created() {
    this.getProgram()
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getCurrent", "hzzx")
    })
    this.getAllMoney()
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: true,
        live: true,
      })
      wow.init()
    }, 200)
  },
  methods: {
    //跳转登录
    Proposals() {
      if (this.$store.state.user.userInfo.phone == undefined) {
        this.$router.push("/login")
      } else {
        this.$router.push("/pmyProgram")
      }
    },
    // 获取项目列表
    async getProgram() {
      let programInfo = new FormData()
      programInfo.append("page", this.paginations.page_index)
      programInfo.append("rows", this.paginations.page_size)
      // programInfo.append("dentity", this.$store.state.user.userInfo.id);
      if (this.keyword) {
        programInfo.append("name", this.keyword)
      }
      programInfo.append("keyword", this.nav[this.currentIndex].status)
      let reg = await getProgramList(programInfo)
      console.log(reg)
      this.paginations.total = reg.total
      this.programData = reg.rows
      this.programData.map((item, index) => {
        item.picture = BASE_URL + item.picture
        item.recipients = Number(item.recipients)
        item.raisefund = Number(item.raisefund)
      })
    },
    // 获取全部统计信息
    async getAllMoney() {
      let money = await getAllList()
      this.totalData[0].total = money.countproject
      this.totalData[1].total = money.countmoney
      this.totalData[2].total = money.countdonatenumber
      this.totalData[3].total = money.countrecipientnumber
    },
    // 切换项目状态
    changNav(item, index) {
      this.currentIndex = index
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.getProgram()
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val
      this.getProgram()
    },
  },
  components: {
    Class,
    AllHeader,
    CountTo,
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
  .program {
    width: 875px;
    margin: 35px auto 100px;
    .pHeader {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .tBox {
        .oneBox {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 210px;
          height: 120px;
          border-radius: 5px;
          box-shadow: 2px 2px 10px #ddd;
          text-align: center;
          font-size: 22px;
          color: #0687c8;
          font-weight: 800;
          h3 {
            margin-bottom: 11px;
            color: #000;
            font-weight: normal;
          }
        }
      }
    }
    .pTitle {
      text-align: center;
      h1 {
        font-size: 26px;
        margin-bottom: 60px;
        font-weight: 600;
      }
      h4 {
        margin-top: 80px;
        margin-bottom: 10px;
      }
    }
    .pNav {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      ul {
        display: flex;
        li {
          height: 30px;
          line-height: 30px;
          font-size: 18px;
          margin-right: 16px;
          cursor: pointer;
          padding: 0 20px;
        }
        .selected {
          color: #ffffff;
          background-color: #0687c8;
          border-radius: 5px;
        }
      }
      h4 {
        width: 120px;
        height: 30px;
        background-color: #0687c8;
        color: #ffffff;
        font-size: 15px;
        text-align: center;
        line-height: 30px;
        border-radius: 5px;
        cursor: pointer;
        i {
          margin-left: 6px;
        }
      }
    }
    .pWrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      min-height: 300px;

      .oneWrapper {
        width: 278px;
        border-radius: 5px;
        border: 1px solid #dbdbdb;
        margin-bottom: 20px;
        margin-right: 17px;
        .show {
          width: 100%;
          height: 156px;
          overflow: hidden;
          position: relative;
          .showImg {
            width: 100%;
            height: 100%;
            transition: 1s all linear;
            &:hover {
              transform: scale(1.2);
            }
          }
          .showIcon {
            position: absolute;
            width: 100px;
            height: 100px;
            top: -5px;
            right: -20px;
            z-index: 10;
          }
        }
        .content {
          padding: 0 20px 30px;
          h2 {
            width: 220px;
            font-weight: 600;
            font-size: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            margin: 24px 0;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          p {
            color: #3b3b3b;
            font-size: 16px;
            line-height: 2;
            display: flex;
          }
        }
      }
    }
    .tspage {
      margin-top: 40px;
      text-align: center;
      /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #0687c8;
        border: none;
      }
      /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        // color: #fff;
      }
      /deep/ .el-pagination.is-background button {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        // color: #fff;
      }
    }
  }
}
</style>
